import * as AppActions from '~app/actions/app';
import createReducer from '~app/core/createReducer';

const initialState = {
  isLoading: false,
  loadingMessage: null,
  loadingProgressPct: null,
  messages: [],
  version: "standard",
};

function loadingStarted(state, {message, progressPct = null}) {
  return {
    ...state,
    isLoading: true,
    loadingMessage: message,
    loadingProgressPct: progressPct,
  };
}

function loadingProgressUpdated(state, {message, progressPct = undefined}) {
  if (progressPct === undefined) {
    progressPct = state.loadingProgressPct;
  }
  return {
    ...state,
    isLoading: true,
    loadingMessage: message,
    loadingProgressPct: progressPct,
  };
}

function loadingFinished(state) {
  return {
    ...state,
    isLoading: false,
  };
}

function createMessage(state, {payload}) {
  return {
    ...state,
    messages: [...state.messages, payload],
  };
}

function clearMessages(state) {
  return {
    ...state,
    messages: [],
  };
}

function setAppVersion(state, { version }) {
  return {
    ...state,
    version,
  };
}

const ACTION_HANDLERS = {
  [AppActions.LOADING_STARTED]: loadingStarted,
  [AppActions.LOADING_PROGRESS_UPDATE]: loadingProgressUpdated,
  [AppActions.LOADING_FINISHED]: loadingFinished,
  [AppActions.CREATE_MESSAGE]: createMessage,
  [AppActions.CLEAR_MESSAGES]: clearMessages,
  [AppActions.SET_APP_VERSION]: setAppVersion,
};

export default createReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/reducers/app.js